var React = require('react');

function WarningInline (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"8.39049","cy":"8.36851","r":"8.30357","fill":"currentColor","key":0}),React.createElement("path",{"d":"M8.10049 10.4668L7.80508 6.29346V4.54785H9.00283V6.29346L8.72353 10.4668H8.10049ZM7.84805 12.4219V11.3208H8.95986V12.4219H7.84805Z","fill":"white","key":1})]);
}

WarningInline.defaultProps = {"width":"17","height":"17","viewBox":"0 0 17 17","fill":"none"};

module.exports = WarningInline;

WarningInline.default = WarningInline;
